module.exports = __webpack_public_path__ + "img/05.8d63c138.png";